module.exports = __webpack_public_path__ + "static/media/twitter-ico.6fa92e05.svg";